export const LocationType = {
  STOP: 0,
  STATION: 1,
  ENTRANCE_OR_EXIT: 2,
  GENERIC_NODE: 3,
  BOARDING_AREA: 4,
};

export const Type = {
  ADDRESS: "ADDRESS",
  GTFS: "GTFS",
  POI: "POI",
};

export const Category = {
  AIRPORT: "AIRPORT",
  BANK: "BANK",
  BAR: "BAR",
  BEACH: "BEACH",
  BRIDGE: "BRIDGE",
  BUS_STOP: "BUS_STOP",
  CAFE: "CAFE",
  EDUCATION: "EDUCATION",
  ENTERTAINMENT: "ENTERTAINMENT",
  FERRY_TERMINAL: "FERRY_TERMINAL",
  GOLF: "GOLF",
  GROCERIES: "GROCERIES",
  HOTEL: "HOTEL",
  LIBRARY: "LIBRARY",
  MARINA: "MARINA",
  MEDICAL: "MEDICAL",
  OUTDOORS: "OUTDOORS",
  OTHER: "OTHER",
  PARKING: "PARKING",
  PETROL: "PETROL",
  POOL: "POOL",
  PUBLIC_TRANSPORT: "PUBLIC_TRANSPORT",
  RESTAURANT: "RESTAURANT",
  RETAIL: "RETAIL",
  SPORTS: "SPORTS",
  STADIUM: "STADIUM",
  TENNIS: "TENNIS",
  TRAIN_STATION: "TRAIN_STATION",
};
